import { render, staticRenderFns } from "./Also.vue?vue&type=template&id=23f066c5&scoped=true&lang=pug&"
import script from "./Also.vue?vue&type=script&lang=js&"
export * from "./Also.vue?vue&type=script&lang=js&"
import style0 from "./Also.vue?vue&type=style&index=0&id=23f066c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f066c5",
  null
  
)

export default component.exports